<template>
  <div class="container">
    <img src="https://cos.eatscope.com/eatscope/h5/img_title.png" alt="" class="topImg"/>
    <img src="https://cos.eatscope.com/eatscope/h5/img_subtitle.png" alt="" class="subtitle"/>
    <img src="https://cos.eatscope.com/eatscope/h5/img_app.png" alt="" class="appImg"/>
    <div class="footer">
      <img class="left" src="../assets/img/img_download_android.png" @click="navToAndroid"/>

      <img class="right" src="../assets/img/img_download_ios.png" @click="goToAppStore"/>
    </div>
    <div v-show="showTip" id="weixinTip" ref="weixin" class="wxtip">
      <p class="jiantou"></p>
      <div class="box-content">
        <div class="item one">
          <i>1</i>点击右上角的<p><span></span></p>按钮
        </div>
        <div class="item two">
          <i>2</i>选择<p><span></span>在浏览器中打开</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {Toast} from 'vant';
import Vue from 'vue';

Vue.use(Toast);

export default {
  name: "sharePage",
  data() {
    return {
      name: "",
      invitedId: this.$route.query.id,
      phoneNum: "",
      codeNum: "",
      btnBool: true,
      showTip: false,
      yzmtext: "获取验证码",
    };
  },
  created() {
    this.isWeixin()
  },
  methods: {
    getInfo() {//获取分享人的昵称
      this.$get("app/getNewestVersion", {
        type: 0,
        number: 1,
      }).then((res) => {
        if (res.code == 200) {
          console.log(res.data.androidUrl)
        }
      })
          .catch(() => {
            // console.log(res)
          });
    },
    isWeixin() {//获取分享人的昵称
      const {userAgent} = navigator
      const isWeixin = !!/MicroMessenger/i.test(userAgent)
      this.isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1
      this.isMac = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isWeixin) {
        //如果是微信环境，就弹出遮罩层
        this.showTip = true
        return true;
      } else {
        this.showTip = false
        return false
      }
    },
    navToAndroid() {
      if(!this.isWeixin()){
        this.$get("app/sys/checkUpdate", {
          versionType: 1,
          versionCurrent: 0,
        }).then((res) => {
          if (res.code == 200) {
            window.open(res.data.versionDownUrl)
          }
        }).catch(() => {
        });
      }
    },
    goToAppStore() {
      window.open("https://apps.apple.com/cn/app/%E5%A5%BD%E7%98%A6/id6526487258")
      // window.open("https://apps.apple.com/cn/app/%E5%A5%BD%E7%98%A6-ai%E6%8B%8D%E7%85%A7%E8%AF%86%E5%88%AB%E5%8D%A1%E8%B7%AF%E9%87%8C/id6526487258?from=groupmessage&isappinstalled=0")
    },
  },
  directives: {
    numberOnly: {
      bind: function (e) {
        e.handler = function () {
          e.value = e.value.replace(/\D+/, "");
        };
        e.addEventListener("input", e.handler);
      },
      unbind: function (e) {
        e.removeEventListener("input", e.handler);
      },
    },
  },
};
</script>
<style>
.container {
  position: fixed;
  background: url("https://cos.eatscope.com/eatscope/h5/img_bg.png");
  background-size: cover;
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  align-items: center;
}

.container .topImg {
  width: 36%;
  margin-top: 5.8%;
}
.container .subtitle {
  width: 65%;
  margin-top: 1.5%;
}

.container .appImg {
  height: 65%;
  margin-top: 2.7%;
}

.container .footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-bottom: env(safe-area-inset-bottom);
  width: 100%;
  margin-top: 7%;
}

.container .footer .left {
  display: flex;
  width: 42.6%;
  border-radius: 500px;
  opacity: 1;
  background: #74C878;
  margin-right: 20px;


}

.container .footer .left .iconImg {
  width: 40px;
}

.container .footer .right {
  display: flex;
  width: 42.6%;
  border-radius: 500px;
  opacity: 1;
  background: #74C878;
}


.container .footer .right .iconImg {
  width: 40px;
}

.container .footer .info {
  color: #fff;
}

.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;

  img {
    width: 100%;
  }
}

.wxtip-txt {
  margin-top: 107px;
  color: #fff;
  font-size: 20px;
  line-height: 1.8;
}


.jiantou {
  background: url('../assets/img/jiantou.png');
  width: 5rem;
  height: 9rem;
  position: absolute;
  top: 0;
  right: 10px;
  background-size: 100% 100%;
}

.box-content {
  position: absolute;
  top: 8rem;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding-left: 6rem;
  background: none;
  color: #fff;
}

.box-content .item {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}

.box-content .item i {
  background: orangered;
  color: #fff;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  line-height: 30px;
  text-align: center;
  font-style: normal;
  margin-right: 10px;
}

.box-content .item p {
  border-radius: 4px;
  padding: 5px;
  background: linear-gradient(to bottom, #8e9297, #6f6f71);
  box-shadow: 2px 2px #000;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 10px;
}

.box-content .item.one span {
  background: url('../assets/img/more.png');
  width: 20px;
  height: 20px;
  background-size: 100% 100%;

}

.box-content .item.two span {
  background: url('../assets/img/liulanqi.png');
  width: 30px;
  height: 30px;
  background-size: 100% 100%;
  margin-right: 5px;
}
</style>
